import { NoAccess } from "@dehub/theme"
import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"
import { IAuth } from "../../interfaces/IAuth"

export type IPermissionCode =
  | "INV_DASH"
  | "INV_CREATE"
  | "INV_REG_PAYMENT"
  | "INV_LIST"
  | "INV_GET"
  | "INV_PDF"
  | "INV_EDIT_DRAFT"
  | "INV_AMEND"
  | "INV_ACCEPT_BUYER_PAYMENT"
  | "INV_DECLINE_BUYER_PAYMENT"
  | "INV_PAY_WITH_B2B"
  | "INV_PAY_WITH_QPAY"
  | "INV_LIST_CLOSED"
  | "INV_LIST_CLOSED_GET"
  | "INV_LIST_CLOSED_PDF"
  | "INV_LIST_CLOSED_EBARIMT"
  | "INV_NETWORK_SETTLEMENT_LIST"
  | "INV_NETWORK_SETTLEMENT_GET_OPEN"
  | "INV_NETWORK_SETTLEMENT_GET_DRAFT"
  | "INV_NETWORK_SETTLEMENT_GET_CLOSED"
  | "INV_NETWORK_SETTLEMENT_PAYMENT_HISTORY"
  | "INV_SETTLEMENT_LIST"
  | "INV_RECONCILIATION_LIST"
  | "INV_SETTLEMENT_GET"
  | "INV_SETTLEMENT_HISTORY"
  | "INV_SETTLEMENT_ACCEPT_PAYMENT"
  | "INV_SETT_RES"
  | "INV_SETTLEMENT_PAYMENT_PDF"
  | "INV_SETT_SEND"
  | "INV_PAYMENT_HISTORY"
  | "INV_RETURNS_LIST"
  | "INV_RETURNS_ACTION"
  | "FINANCE"
  | "RETURN_VIEW"
  | "RETURN_CREATE"
  | "RETURN_CONFIRM_REFUND"

export function usePermission(code: IPermissionCode) {
  const { t } = useTranslation("common")
  const { user } = useSelector((state: { auth: IAuth }) => state.auth)

  const hasAccess = user?.permissions?.some((som: any) => som.code === code) || false

  /** Тайван карт (улаан alert биш): theme-ийн NoAccess, эрхийн код mono-оор. */
  function accessDenied() {
    return <NoAccess permission={code} />
  }

  /** Эрхгүй үед товчны tooltip-д харуулах шалтгаан (эрхтэй бол undefined). */
  const reason = hasAccess ? undefined : t("permissionRequired", { code })

  return {
    hasAccess,
    accessDenied,
    reason,
  }
}
